import SoftwareVersionService from 'actions/version/software_version_service';
import qconsole from 'scripts/lib/qconsole';

export default function() {
  SoftwareVersionService.getVersion = () => global.about.version;

  SoftwareVersionService.upgrade = () => {
    qconsole.log(`Upgrading Gladly software by reloading the browser at [${window.location}]`);
    window.location.reload(true);
  };
}



// WEBPACK FOOTER //
// ./src/scripts/configuration/configure_software_version_service.js